export const expertPayOrderEn = {
    zfcgts:"订单交易成功，请享受专家咨询服务"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertPayOrder/indexEn.js